import { render } from "./FairUnbox.vue?vue&type=template&id=2c1fc2c0&scoped=true"
import script from "./FairUnbox.vue?vue&type=script&lang=js"
export * from "./FairUnbox.vue?vue&type=script&lang=js"

import "./FairUnbox.vue?vue&type=style&index=0&id=2c1fc2c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1fc2c0"]])

export default __exports__